import React, { useEffect, useState } from "react";
import Modal from "../../../components/modal";
import axios from "axios";
import Swal from "sweetalert2";
import { API_URL } from "../../../utils/constant";

const AccountingForm = ({
  show,
  onClose,
  heading,
  initialData,
  onSuccess,
}) => {
  const initialFormState = {
    company_id: "",
    name: "",
    code: "",
    identification: "",
    is_subledger: false,
    type: "",
    account_no: "",
    ifsc_code: "",
    classification: "",
    is_loan_account: false,
    tds_applicable: false,
    address: "",
    pan: "",
  };

  const [formData, setFormData] = useState(initialFormState);
  const [loading, setLoading] = useState(false);

  // Generate Code automatically
  const generateCode = (name) => {
    return name
      ?.toUpperCase()
      .replace(/\s+/g, "_")
      .substring(0, 10);
  };

  useEffect(() => {
    const company_id = localStorage.getItem("companyID");

    if (initialData) {
      setFormData({
        ...initialData,
        is_subledger: initialData.is_subledger || false,
        is_loan_account: initialData.is_loan_account || false,
        tds_applicable: initialData.tds_applicable || false,
      });
    } else {
      setFormData({
        ...initialFormState,
        company_id,
      });
    }
  }, [initialData, show]);

  // Handle form change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Auto-generate code from name
    if (name === "name") {
      setFormData((prev) => ({
        ...prev,
        name: value,
        code: generateCode(value),
      }));
      return;
    }

    // Handle checkbox inputs
    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked,
      }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.type) {
      Swal.fire("Validation Error", "Name and Type are required fields", "warning");
      return;
    }

    try {
      setLoading(true);

      if (initialData?.id) {
        await axios.put(
          `${API_URL}/accounting/accounting/${initialData.id}`,
          formData
        );
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "The Account has been updated.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });
      } else {
        await axios.post(`${API_URL}/accounting/accounting`, formData);
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "The Account has been created.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });
      }

      onClose();
      onSuccess();
    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.message || "Something went wrong",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onClose={onClose} heading={heading}>
      <form onSubmit={handleSubmit}>
        <div className="row">
          {/* Account Name */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Account Name <span className="text-danger">*</span></label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          {/* Auto Code */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Code</label>
            <input
              type="text"
              className="form-control"
              value={formData.code}
              readOnly
            />
          </div>

          {/* Identification */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Identification</label>
            <input
              type="text"
              className="form-control"
              name="identification"
              value={formData.identification}
              onChange={handleChange}
            />
          </div>

          {/* Type */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Type <span className="text-danger">*</span></label>
            <select
              className="form-select"
              name="type"
              value={formData.type}
              onChange={handleChange}
              required
            >
              <option value="">Select Type</option>
              <option value="Asset">Asset</option>
              <option value="Liability">Liability</option>
              <option value="Equity">Equity</option>
              <option value="Revenue">Revenue</option>
              <option value="Expense">Expense</option>
            </select>
          </div>

          {/* Account Number */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Account Number</label>
            <input
              type="text"
              className="form-control"
              name="account_no"
              value={formData.account_no}
              onChange={handleChange}
            />
          </div>

          {/* IFSC Code */}
          <div className="col-md-6 mb-3">
            <label className="form-label">IFSC Code</label>
            <input
              type="text"
              className="form-control"
              name="ifsc_code"
              value={formData.ifsc_code}
              onChange={handleChange}
            />
          </div>

          {/* Classification */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Classification</label>
            <input
              type="text"
              className="form-control"
              name="classification"
              value={formData.classification}
              onChange={handleChange}
            />
          </div>

          {/* PAN */}
          <div className="col-md-6 mb-3">
            <label className="form-label">PAN</label>
            <input
              type="text"
              className="form-control"
              name="pan"
              value={formData.pan}
              onChange={handleChange}
            />
          </div>

          {/* Checkboxes */}
          <div className="col-md-4 mb-3">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                name="is_subledger"
                id="is_subledger"
                checked={formData.is_subledger}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="is_subledger">
                Is Subledger
              </label>
            </div>
          </div>

          <div className="col-md-4 mb-3">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                name="is_loan_account"
                id="is_loan_account"
                checked={formData.is_loan_account}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="is_loan_account">
                Is Loan Account
              </label>
            </div>
          </div>

          <div className="col-md-4 mb-3">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                name="tds_applicable"
                id="tds_applicable"
                checked={formData.tds_applicable}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="tds_applicable">
                TDS Applicable
              </label>
            </div>
          </div>

          {/* Address */}
          <div className="col-12 mb-3">
            <label className="form-label">Address</label>
            <textarea
              className="form-control"
              name="address"
              value={formData.address}
              onChange={handleChange}
              rows="3"
            />
          </div>
        </div>

        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-light me-2"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AccountingForm;
